<template>
  <div :hide="hide" class="text-counter-limiter">
    <p data-testid="counter-limiter-content"><span :class="{ limit_exceeded: isLimitExceeded }">{{text.length}}</span>/{{limit}}</p>
  </div>
</template>

<script>

  export default {
    name: "TextCounterLimiter",
    data() {
     return {
       limitExceeded: false
     }
    },
    props: {
      text: {
        type: String,
        required: true
      },
      limit: {
        type: Number,
        required: true
      },
      hide: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isLimitExceeded() {
        let exceeded = this.text.length > this.limit
        if (exceeded !== this.limitExceeded) {
          this.limitExceeded = exceeded
          this.$emit('textLimitExceeded', this.limitExceeded)
        }
        return this.limitExceeded
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";

  .limit_exceeded {
    color: $error_msg;
  }
  .text-counter-limiter {
    font-family: var(--primary-font-family);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 0.7;
    color: $grey-color-17;
    margin-inline-end: 10px;
  }

  [hide]{
    display: none;
  }

</style>
